<template>
  <div class='app-container'>

    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_cabinet_list'
      params>
      <div>
        <span class='left-table'>机柜编号：</span>
        <el-input v-model='device_id' placeholder='请输入机柜编号' style='width: 200px;' clearable></el-input>
        <span class='left-table'>
          充电设备类型：
          <el-select v-model='dev_type' placeholder='请选择' clearable>
            <el-option
              v-for='item in deviceTypeList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>
      </div>
    </icare-table>

    <!-- 编辑信息 -->
    <el-dialog title='自编号设置' :visible.sync='editVisible' width='50%' @closed='closeDialog'>
      <el-form ref='form' :model='form' :rules='rules' label-width='200px'>
        <el-row :gutter='24'>
          <el-col :span='12'>
            <el-form-item label='通道ID' :label-width='formLabelWidth' prop='channel_id'>
              <el-input v-model='form.channel_id' disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter='24'>
          <el-col :span='12'>
            <el-form-item label='自编号' :label-width='formLabelWidth' prop='code'>
              <el-input v-model.number='form.code'></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeDialog'>取 消</el-button>
        <el-button type='primary' @click='save'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog title='微信小程序码' :visible.sync='createQRCodeVisible'>
      <el-row :gutter='20'>
        <el-col :offset='6'>
          <div class='block'>
            <el-image :src='base64QRCode' style='width: 50%;height: 50%'>
              <div slot='placeholder' class='image-slot'>
                加载中<span class='dot'>...</span>
              </div>
            </el-image>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter='20'>
        <el-col :offset='10'>
          <span class='demonstration'> {{ qrCodeTip }}</span>
        </el-col>
      </el-row>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='closeQRCodeDialog'>取 消</el-button>
        <el-button type='primary' @click='downloadQRCode'>下 载</el-button>
      </div>
    </el-dialog>
    <!-- 详情弹出框 -->
    <el-dialog :title="'机柜编号:'+ cmdForm.device_id+'-自编号:'+cmdForm.code+'号'" :visible.sync='cmdVisible'
               @close='handleCmdCancel'
               top='8vh' width='58%'>
      <el-form ref='cmdForm' :model='cmdForm' label-width='100px'>
        <el-row :gutter='24'>
          <el-col :span='24'>
            <el-form-item label='命令选项：' prop='ctrl'
                          :rules="[{ required: 'true', message: `请选择命令项`,trigger: 'change'}]">
              <el-radio-group v-model='cmdForm.ctrl' @change='handleCmdRadio'>
                <el-card style='height: 150px;width: 100%'>
                  <div slot='header' class='clearfix'>
                    <el-button style='float: left; padding: 3px 0' type='text'>充电格</el-button>
                  </div>
                  <el-radio label='open_grid' :disabled='cmdForm.device_type==0?false:true'>
                    打开柜门
                  </el-radio>
                  <el-radio label='open_light' :disabled='cmdForm.device_type==0?false:true'>
                    打开照明灯
                  </el-radio>
                  <el-radio label='close_light' :disabled='cmdForm.device_type==0?false:true'>
                    关闭照明灯
                  </el-radio>
                  <el-radio label='open_fan' :disabled='cmdForm.device_type==0?false:true'>
                    打开风扇
                  </el-radio>
                  <el-radio label='close_fan' :disabled='cmdForm.device_type==0?false:true'>
                    关闭风扇
                  </el-radio>
                </el-card>
                <el-card class='box-card' style='height: 150px;margin-top: 10px;width:100%'>
                  <div slot='header' class='clearfix'>
                    <el-button style='float: left; padding: 3px 0' type='text'>充电板</el-button>
                  </div>

                  <el-radio label='reset_ac'>
                    复位控制
                  </el-radio>
                  <el-radio label='start_charge'>
                    开始充电
                  </el-radio>
                  <el-radio label='stop_charge'>
                    停止充电
                  </el-radio>
                </el-card>
                <!--                <el-radio label="reset_cli">&ndash;&gt;-->
                <!--                  复位终端-->
                <!--                </el-radio>-->
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter='24'>
          <el-col :span='14'>
            <el-form-item label='命令参数：' prop='Parameter'>
              <div v-if="cmdForm.ctrl =='start_charge'">
                <el-input v-model='cmdForm.duration' clearable :disabled='isDisabled' maxlength='50'
                          tabindex='4'>
                  <template slot='append'>秒</template>
                </el-input>
              </div>
              <div v-else>
                <el-input v-model='cmdForm.param' clearable :disabled='isDisabled' maxlength='50'
                          tabindex='4'></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span='6'>

            <el-button icon='el-icon-caret-right' type='danger' plain @click='sendCmd'>
              执行命令
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position='left'></el-divider>

      <span slot='footer' class='dialog-footer'>
                <el-button @click='handleCmdCancel'>关闭</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import { getCookie } from '@/utils/auth'


export default {
  data() {

    return {
      workgroup_id: null,
      loading: false,
      device_id: null,
      dev_type: null,
      createQRCodeVisible: false,
      base64QRCode: '',
      qrCodeTip: '',
      //命令窗口
      cmdVisible: false,
      isDisabled: true,
      cmdForm: {
        ctrl: null,
        device_id: null,
        sn: null,
        cn: null,
        box_sn: null,
        duration: null
      },

      tableParams: {
        device_id: null,
        dev_type: null
      },

      deviceTypeList: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 0,
          label: '充电仓'
        },
        {
          value: 1,
          label: '充电插座'
        }
      ],
      titleConfig: [
        {
          field: 'id',
          title: '机柜编号',
          visible: true
        },
        {
          field: 'device_name',
          title: '机柜名称',
          visible: false
        },
        {
          field: 'channel_id',
          title: '充电板ID',
          visible: false
        },
        {
          field: 'type',
          title: '充电设备类型',
          visible: true,
          fuc: val => {
            let v
            switch (val) {
              case 0:
                v = '<div style="color:#E6A23C">充电仓</div>'
                break
              case 1:
                v = '<div style="color:#409EFF">充电插座</div>'
                break
            }
            return v
          }
        },
        {
          field: 'code',
          title: '充电设备自编号',
          visible: true,
          fuc: function(title, item, row) {
            if (row.code != '') {
              if (row.type == 0) {
                return '<div style="color:#E6A23C">' + (((parseInt(row.code)) > 9) ? row.code : '0' + row.code) + ' 号充电仓</div>'
              } else {
                return '<div style="color:#409EFF">' + (((parseInt(row.code)) > 9) ? row.code : '0' + row.code) + '充电插座</div>'
              }
            } else {
              return '-'
            }
          }
        },

        {
          field: 'sn',
          title: '充电板序列编号',
          visible: false
        },
        {
          field: 'cn',
          title: '充电端口',
          visible: false
        },

        {
          field: 'u',
          title: '充电电压',
          visible: true,
          fuc: val => {
            return (val / 10).toFixed(2) + 'V'
          }
        },
        {
          field: 'i',
          title: '充电电流',
          visible: true,
          fuc: val => {
            return (val / 1000).toFixed(2) + 'A'
          }
        },
        {
          field: 'stg',
          title: '充电状态',
          visible: true,
          fuc: val => {
            let v
            switch (val) {
              case 0:
                v = '<div style="color:#67C23A">空闲</div>'
                break
              case 1:
                v = '<div style="color:#409EFF">等待</div>'
                break
              case 2:
                v = '<div style="color:#409EFF">延迟</div>'
                break
              case 3:
                v = '<div style="color:#409EFF">快充</div>'
                break
              case 4:
                v = '<div style="color:#409EFF">浮充</div>'
                break
              case 5:
                v = '<div style="color:#909399">完成</div>'
                break
              case 6:
                v = '<div style="color:#F56C6C">错误-电流超标</div>'
                break
              case 7:
                v = '<div style="color:#F56C6C">错误-没有电流</div>'
                break
              case 8:
                v = '<div style="color:#F56C6C">错误-电流突增</div>'
                break
              case 9:
                v = '<div style="color:#F56C6C">错误-电压超标</div>'
                break
              case 10:
                v = '<div style="color:#909399">结束</div>'
                break
              case 11:
                v = '<div style="color:#E6A23C">强制充电</div>'
                break
            }
            return v
          }
        },
        {
          field: 'box_sn',
          title: '充电仓序列编号',
          visible: true,
          fuc: val => {
            return val == 0 ? '-' : val
          }
        },
        {
          field: 'grid_stat',
          title: '充电仓状态',
          visible: true,
          fuc: function(title, item, row) {
            if (row.type == 0) {
              let s = ''
              let val = row.grid_stat
              if ((val & 0x0001) > 0) { //0
                s += '直流风机故障-'
              }

              if ((val & 0x0002) > 0) {//1
                //s += '门已关闭-'
              } else {
                s += '门已打开-'
              }

              if ((val & 0x0004) > 0) {//2
                s += '烟感报警-'
              }

              if ((val & 0x0008) > 0) {//3
                s += '电池异常-'
              }

              if ((val & 0x0010) > 0) {//4

              }

              if ((val & 0x0020) > 0) {//5

              }
              if ((val & 0x0040) > 0) {//6

              }
              if ((val & 0x0080 > 0)) {//7

              }
              if ((val & 0x0100) > 0) {//8
                s += '照明灯-'
              }
              if ((val & 0x0200) > 0) {//9
                s += '电磁锁-'
              }
              if ((val & 0x0400) > 0) {//10
                s += '加热器-'
              }
              if ((val & 0x0800) > 0) {//11
                s += '交流风机-'
              }
              if ((val & 0x1000) > 0) {//12
                s += '直流风机-'
              }
              if ((val & 0x2000) > 0) {//13
                s += '红灯-'
              }
              if ((val & 0x4000) > 0) {//14
                s += '绿灯-'
              }
              if ((val & 0x8000) > 0) {//15 ledRGB蓝色
                s += '黄灯-'
              }
              if (s.length > 0) {
                s = '<div style="color:#F56C6C">' + s + '开启</div>'
              } else {
                s = '<div style="color:#67C23A">正常</div>'
              }
              return s
            } else {
              return '-'
            }
          }
        },
        {
          field: 'grid_err',
          title: '充电仓故障',
          visible: true,
          fuc: function(title, item, row) {
            if (row.type == 0) {
              return row.grid_err == 0 ? '<div style="color:#67C23A">正常</div>' : '<div style="color:#F56C6C">离线</div>'
            } else {
              return '-'
            }
          }
        },
        {
          field: 'grid_t1',
          title: '充电仓温度1',
          visible: true,

          fuc: function(title, item, row) {
            if (row.type == 0) {
              return (row.grid_t1 / 100).toFixed(2) + '度'
            } else {
              return '-'
            }
          }
        },
        {
          field: 'grid_t2',
          title: '充电仓温度2',
          visible: true,
          fuc: function(title, item, row) {
            if (row.type == 0) {
              return (row.grid_t2 / 100).toFixed(2) + '度'
            } else {
              return '-'
            }
          }
        },
        {
          field: 'grid_com',
          title: '充电仓通讯',
          visible: true,

          fuc: function(title, item, row) {
            if (row.type == 0) {
              let v
              let val = row.grid_com
              switch (val) {
                case 0:
                  v = '<div style="color:#67C23A">正常</div>'
                  break
                case 1:
                  v = '<div style="color:#F56C6C">离线</div>'
                  break
              }
              return v
            } else {
              return '-'
            }
          }
        },

        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '远程命令',
              icon: 'el-icon-mouse',
              fuc: row => {
                this.handleCmd(row)
              }
            },
            {
              title: '生成二维码',
              icon: ' el-icon-full-screen',
              fuc: this.createQRCode
            },
            {
              title: '充电设备自编号',
              icon: 'el-icon-edit-outline',
              fuc: this.showEdit
            },
            {
              title: '删除',
              color: '#F56C6C',
              icon: 'el-icon-delete',
              fuc: this.delete
            }
          ]
        }
      ],
      //编辑信息
      editTip: '',

      form: {
        id: '',
        sn: '',
        cn: '',
        code: '',
        channel_id: ''
      },
      rules: {},

      formLabelWidth: '100px',
      editVisible: false,
      dialogType: 0
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.station_id = parseInt(this.$route.query.station_id)
    this.tableParams.station_id = parseInt(this.$route.query.station_id)
  },
  methods: {

    // //弹出编辑(新增)对话框
    // showAdd() {
    //   this.dialogType = 1
    //   this.editVisible = true
    //   this.editTip = '新增信息'
    //   this.form = Object.assign({ id: 0, agency_id: parseInt(getCookie('agency_id')), base_energy_charge: 0.0 })
    // },
    //弹出编辑(新增)对话框
    showEdit(row) {
      this.editVisible = true

      this.form.code = row.code
      this.form.channel_id = row.channel_id
    },
    //关闭编辑对话框
    closeDialog() {
      console.log('closeDialog')
      this.editVisible = false


      this.$refs['form'].resetFields()
      this.$refs['form'].clearValidate()
    },
    //模糊搜索
    find() {
      this.tableParams.device_id = this.device_id
      this.tableParams.dev_type = this.dev_type
      this.$refs.table.refresh()
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.work_group_name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_workgroup',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {
      this.$refs.form.validate(valid => {
        if (valid) {

          let str = JSON.stringify({
            id: this.form.channel_id,
            code: this.form.code + ''
          })

          gateway({
            func: 'set_db_channel_code',
            params: str
          }).then(() => {
            this.closeDialog()
            this.$refs.table.refresh()
          })
        } else {
          return false
        }
      })
    },

    handleCmd(row) {
      this.cmdVisible = true
      // console.log('row---------', row)
      this.cmdForm = {
        code: row.code,
        device_type: row.type,
        device_id: row.id,
        box_sn: row.box_sn,
        sn: row.sn,
        cn: row.cn
      }
    },
    handleCmdCancel() {
      this.cmdVisible = false
    },

    handleCmdRadio(val) {

      if (val == 'open_grid' || val == 'open_light' || val == 'close_light' || val == 'open_fan' || val == 'open_fan' || val == 'reset_ac' || val == 'reset_cli' || val == 'close_fan' || val == 'stop_charge') {
        this.isDisabled = true
      } else {
        this.cmdForm.duration = 300, //5分钟
          this.isDisabled = false
      }

      this.cmdForm = {
        code: this.cmdForm.code,
        device_type: this.cmdForm.device_type,
        device_id: this.cmdForm.device_id,
        box_sn: this.cmdForm.box_sn,
        sn: this.cmdForm.sn,
        ctrl: val,
        duration: this.cmdForm.duration,
        cn: this.cmdForm.cn
      }
    },

    sendCmd() {
      this.$refs.cmdForm.validate(valid => {
        if (valid) {

          var form = Object.assign({}, this.cmdForm)
          if (form.ctrl == 'open_grid' || form.ctrl == 'open_light' || form.ctrl == 'close_light' || form.ctrl == 'open_fan' || form.ctrl == 'open_fan' || form.ctrl == 'close_fan') {
            form.sn = form.box_sn
          }


          form.device_id = parseInt(form.device_id)

          let str = JSON.stringify(form)
          gateway({
            func: 'set_db_dev_ctrl',
            params: str
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')

            } else {
              this.$message.error('操作失败：'+res.msg)
            }
          })
        } else {
          return false
        }
      })
    },

    //QRCode func
    closeQRCodeDialog() {
      this.createQRCodeVisible = false
      this.base64QRCode = ''
      this.form = {}
    },

    createQRCode(row) {
      this.form = null
      this.base64QRCode = ''
      this.qrCodeTip = ''

      this.createQRCodeVisible = true
      var scene = row.id   //TODO

      if (row.type == 0) { //柜内-充电柜
        scene = row.id
        this.qrCodeTip = '柜内(充电桩)：' + scene
      } else {    //柜外-充电桩
        scene = row.id + '.' + row.sn + '.' + row.cn + '.' + row.code
        this.qrCodeTip = '柜外(充电桩)：' + scene
      }

      let str = JSON.stringify({
        scene: scene,
        page: 'pages/consumer/pay/index'
      })
      gateway({
        func: 'mini_program_qr',
        params: str
      }).then((data) => {
        if (data != null && data.code == 0) {
          this.base64QRCode = 'data:image/jpg;base64,' + data.result
          this.form = Object.assign({ id: '', code: '' }, row)
        }
      })
    },
    downloadQRCode() {
      this.downloadFile(this.qrCodeTip + '.jpg', this.base64QRCode)
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content) //new Blob([content]);
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      //aLink.click()
      aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }))//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    }
  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}

.amap-demo {
  height: 400px;
}
</style>
